.menu-item {
  font-size: 1.4rem;
  height: 3.2rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0.8rem;
  gap: 0.8rem;
  overflow: hidden;
  color: #ADB5BD;

  svg {
    min-width: 1.6rem;
  }

  span {
    white-space: nowrap;
  }

  .external-icon {
    margin-left: auto;
    opacity: 0.7;
  }

  &:hover {
    cursor: pointer;
    background: var(--color-surface-tertiary);
  }

  &[data-is-active='true'] {
    color: var(--color-text-primary);
    background: var(--color-surface-tertiary);
  }
}
